export default "__VITE_ASSET__B0SrZ4N4__"